const initState = {
    type: '',
    iconList: [],
    currentIcon: null,
    response: null,
    error: null
}

const iconReducer = (state = initState, action) => {

    switch (action.type) {
        case 'ICON_INIT': return { ...state, type: action.type, error: null, currentIcon: action.payload }

        case 'ICON_LIST_PENDING': return { ...state, type: action.type, error: null }
        case 'ICON_LIST_SUCCESS': return { ...state, type: action.type, error: null, iconList: action.payload }
        case 'ICON_LIST_ERROR': return { ...state, type: action.type, error: action.payload, iconList: [] }

        case 'ICON_SELECT_PENDING': return { ...state, type: action.type, error: null }
        case 'ICON_SELECT_SUCCESS': return { ...state, type: action.type, error: null, currentIcon: action.payload }
        case 'ICON_SELECT_ERROR': return { ...state, type: action.type, error: action.payload }

        case 'ICON_CREATE_PENDING': return { ...state, type: action.type, error: null }
        case 'ICON_CREATE_SUCCESS': return { ...state, type: action.type, error: null, response: action.payload }
        case 'ICON_CREATE_ERROR': return { ...state, type: action.type, error: action.payload }

        case 'ICON_UPDATE_PENDING': return { ...state, type: action.type, error: null }
        case 'ICON_UPDATE_SUCCESS': return { ...state, type: action.type, error: null, response: action.payload }
        case 'ICON_UPDATE_ERROR': return { ...state, type: action.type, error: action.payload }

        case 'ICON_DELETE_PENDING': return { ...state, type: action.type, error: null }
        case 'ICON_DELETE_SUCCESS': return { ...state, type: action.type, error: null, response: action.payload }
        case 'ICON_DELETE_ERROR': return { ...state, type: action.type, error: action.payload }

        case "SET_ICON_LIST": {
            return { ...state, iconList: action.payload }
        }

        default: return state;
    }
};

export default iconReducer;